/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { forceNormalizeString } from '../interpreter/ArithmeticHelper';
import { rangeLowerBound } from '../interpreter/binarySearch';
import { getRawValue } from '../interpreter/InterpreterValue';
import { AdvancedFind } from './AdvancedFind';
export class ColumnBinarySearch extends AdvancedFind {
    constructor(dependencyGraph, config) {
        super(dependencyGraph);
        this.dependencyGraph = dependencyGraph;
        this.config = config;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars 
    add(value, address) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    remove(value, address) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    change(oldValue, newValue, address) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addColumns(columnsSpan) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeColumns(columnsSpan) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeSheet(sheetId) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    moveValues(sourceRange, toRight, toBottom, toSheet) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeValues(range) { }
    destroy() { }
    find(key, range, sorted) {
        if (typeof key === 'string') {
            key = forceNormalizeString(key);
        }
        if (range.height() < this.config.binarySearchThreshold || !sorted) {
            const values = this.dependencyGraph.computeListOfValuesInRange(range).map(getRawValue).map(arg => (typeof arg === 'string') ? forceNormalizeString(arg) : arg);
            const index = values.indexOf(key);
            return index < 0 ? index : index + range.start.row;
        }
        else {
            return rangeLowerBound(range, key, this.dependencyGraph, 'row');
        }
    }
}
